










































import Vue from 'vue';
import Component from 'vue-class-component';
import AuthService from '@/services/AuthService';
import LayoutService from '@/services/LayoutService';
import { Action } from 'vuex-class';

@Component({})
export default class AdminLayout extends Vue {
  @Action('logout', { namespace: 'auth' })
  protected logout!: () => Promise<void>;

  protected menuItems: Array<{ title: string, icon: string, link: string }> = [
    { title: 'Producten', icon: 'shopping_cart', link: '/beheer/producten' },
    // { title: 'Vertalingen', icon: 'translate', link: '/beheer/vertalingen' },
  ];

  protected exitApp() {
    this.logout();
    this.$router.push('/');
  }

  protected created() {
    LayoutService.admin();
  }
}
